import appConfig from "../../config.json";

const SESSION_ORG_KEY = "cimis.orgId";

function storedOrgId(): number | null {
  const raw = localStorage.getItem(SESSION_ORG_KEY);
  const value = Number(raw);
  return Number.isInteger(value) && value > 0 ? value : null;
}

/** 当前登录组织。注册/登录后写入，不再使用构建时写死的 config.orgId。 */
export let orgId = storedOrgId() ?? Number(appConfig.orgId ?? 1);

export function hasSessionOrgId(): boolean {
  return storedOrgId() != null;
}

export function setSessionOrgId(id: number): void {
  if (!Number.isInteger(id) || id <= 0) return;
  localStorage.setItem(SESSION_ORG_KEY, String(id));
  orgId = id;
}

export function clearSessionOrgId(): void {
  localStorage.removeItem(SESSION_ORG_KEY);
  orgId = Number(appConfig.orgId ?? 1);
}

export function apiBaseUrl(): string {
  return String(appConfig.apiBaseUrl ?? "http://127.0.0.1:8000").replace(/\/$/, "");
}

export function apiAssetUrl(path: string): string {
  return path.startsWith("http") ? path : `${apiBaseUrl()}${path}`;
}

export const webUrl = String(appConfig.webUrl ?? "http://localhost:5173");
